import React, { Fragment } from 'react';
import AddBoxIcon from '@material-ui/icons/AddBox';
import IconButton from '@material-ui/core/IconButton';
import Tooltip from '@material-ui/core/Tooltip';

const SearchModalMedicinesTableActions = ({ data, Callback }) => {

  return (<Fragment>
    <td role="cell">
      <Tooltip title="Agregar">
        <IconButton onClick={() => {
          Callback(data.data.original);
        }}>
          <AddBoxIcon />
        </IconButton>
      </Tooltip>
    </td>
  </Fragment>)
}

export default SearchModalMedicinesTableActions;